<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        data-follow-fill="currentColor"
        d="M4.1 21.8c-1.6 0-2.9-1.2-2.9-2.8V5.3c0-1.6 1.2-2.9 2.8-2.9h3.3c.5 0 .8.4.9.8 0 .4-.3.8-.8.9H4.2c-.6 0-1.2.5-1.2 1.2V19c0 .6.5 1.2 1.2 1.2h3.2c.5 0 .8.4.9.8 0 .4-.3.8-.8.8H4.1zm7.4-1.6c-1.6 0-2.9-1.2-2.9-2.8V6.8c0-1.6 1.2-2.9 2.8-2.9h8.5c1.6 0 2.9 1.2 2.9 2.8v10.6c0 1.6-1.2 2.9-2.8 2.9h-8.5zm0-14.7c-.6 0-1.2.5-1.2 1.2v10.6c0 .6.5 1.2 1.2 1.2H20c.6 0 1.2-.5 1.2-1.2V6.7c0-.7-.6-1.2-1.2-1.2h-8.5zM5.2 17c-.5 0-.8-.4-.8-.8 0-.2.1-.4.2-.6.2-.2.4-.2.6-.2h1c.5 0 .8.4.8.8 0 .2-.1.4-.2.6-.1.2-.3.2-.6.2h-1zm8.4-.5c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h4.2c.5 0 .8.4.8.8 0 .5-.4.8-.8.8h-4.2zm0-3.7c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h4.2c.5 0 .8.4.8.8 0 .5-.4.8-.8.8h-4.2zm-8.4 0c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h1c.5 0 .8.4.8.8 0 .2-.1.4-.2.6-.2.2-.4.2-.6.2h-1zm8.4-3.6c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h4.2c.5 0 .8.4.8.8 0 .5-.4.8-.8.8h-4.2zm-8.4-.5c-.5 0-.8-.4-.8-.8s.3-.9.8-.9h1c.5 0 .8.4.8.8s-.3.9-.8.9h-1z"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
